module.exports = __webpack_public_path__ + "static/media/detalle-verde.ddf1d919.svg";